import { Directive, Input, OnInit } from '@angular/core';

@Directive()
export abstract class BaseTipsComponent implements OnInit {
  @Input() abstract matIcon: string;
  @Input() abstract cssColor: string;
  @Input() abstract txtColor: string;

  private _bgColor: string = 'transparent';
  get bgColor(): string {
    return this._bgColor;
  }

  ngOnInit() {
    var cssColor = getComputedStyle(document.documentElement).getPropertyValue(this.cssColor)?.trim();
    if (cssColor) {
      this._bgColor = cssColor;
    } else {
      console.warn(`${this.cssColor} not found in css variables`);
    }
  }
}
